import { useContext } from "react";

import { SessionSettingsContext } from "../../contexts/user/SessionSettingsContext";

const useSessionSettings = () => {
  const context = useContext(SessionSettingsContext);

  if (!context) throw new Error("SessionSettingsContext must be used inside SessionSettingsProvider");

  return context;
};

export default useSessionSettings;
